import React, { useState } from "react";
import MyIcon from "../MyIcon";
import MyBadge from "../MyBadge";
import CalendarIcon from "../../../assets/icons/cal_event-01.svg2";
import { Accordion, Button, Nav, Pagination, Tab, Tabs } from "react-bootstrap";
import TickIcon from "../../../assets/icons/tick.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faContactCard,
  faLocation,
  faLocationPin,
  faTimes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import MyPagination from "../MyPagination";

const tabs = [
  {
    name: "workSchedule",
    heading: "Work Schedule",
    events: "300",
  },
  {
    name: "default",
    heading: "Default",
    events: "30",
  },
];

export default function CalendarsFound() {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  return (
    <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 ">
      <div className="d-flex mb-3 ">
        <div>
          <MyIcon Icon={CalendarIcon} width={40} className="me-2" />
        </div>
        <div>
          <div className="fw-bold">
            <MyBadge count={2} />
            <span className="fs-4 fw-bold ms-2">Calendars Found</span>
          </div>
          <div className="small opacity-50 m-2">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </div>
        </div>
      </div>
      <Tab.Container
        id="calendar-found-tabs"
        activeKey={selectedTab.name}
        onSelect={(tab) => setSelectedTab(tabs.find((t) => t.name === tab))}
      >
        <Nav variant="tabs" className="">
          {tabs.map((t) => (
            <Nav.Item className="bg-transparent">
              <Nav.Link eventKey={t.name} className="fw-bold bg-transparent">
                <div className=" ms-2">
                  <MyBadge count={t.events + " EVENTS"} />
                </div>
                <div className="text-black fw-bold fs-5  ms-4 mt-2 ">
                  {t.heading}
                </div>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="workSchedule">
            <div className="fw-bold py-3">
              Showing 50 of 300 events in the calendar "Work Schedule"
            </div>
            <div
              className="overflow-auto d-flex flex-column p-3"
              style={{
                maxHeight: 300,
                scrollbarColor:
                  "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
              }}
            >
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0" className="rounded-4 overflow-hidden mb-3 ">
                  <Accordion.Header>
                    <div className="row flex-grow-1">
                      <div className="col-2 p-1 text-center fw-bold text-purple">
                        <div className="bg-purple-gradient rounded-top-3 fs-3 ">
                          8
                        </div>
                        <div className="bg-dark-purple  text-white rounded-bottom-3 ">
                          Apr
                        </div>
                      </div>

                      <div className="col-10">
                        <h5 className="fw-bold">Engineer Appointment</h5>
                        <h6 className="small opacity-50 ">
                          Lorem ipsum dolor sit amet consectetur...
                        </h6>
                        <div className="d-flex ">
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon
                              icon={faLocationPin}
                              className="me-2"
                            />
                            Location:
                            <span className=" opacity-50 ">London,UK</span>
                          </span>
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon icon={faUser} className="me-2" />
                            Contacts:
                            <span className=" opacity-50 ">25</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="bg-white mt-3 ">
                      <div>
                        <span className="d-flex align-items-center">
                          <TickIcon width={15} />
                          <h5 className=" p-1 small">location</h5>
                        </span>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="1"
                  className=" mb-3  rounded-4 overflow-hidden"
                >
                  <Accordion.Header>
                    <div className="row flex-grow-1  ">
                      <div className="col-2 p-1 text-center fw-bold text-purple">
                        <div className="bg-purple-gradient rounded-top-3 fs-3 ">
                          24
                        </div>
                        <div className="bg-dark-purple  text-white rounded-bottom-3  ">
                          May
                        </div>
                      </div>
                      <div className="col-10">
                        <h5 className="fw-bold">Town Hall Meeting</h5>
                        <h6 className="small opacity-50">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Inventore ratione cupiditate hic asperiores
                          illum dignissimos reprehenderit quidem dolore amet!
                          Facere
                        </h6>
                        <div className="d-flex ">
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon icon={faClock} className="me-2" />
                            Time:
                            <span className=" opacity-50 ">
                              10.30am-12.30pm
                            </span>
                          </span>
                        </div>
                        <div className="d-flex ">
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon
                              icon={faLocationPin}
                              className="me-2"
                            />
                            Location:
                            <span className=" opacity-50 ">London,UK</span>
                          </span>
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon icon={faUser} className="me-2" />
                            Contacts:
                            <span className=" opacity-50 ">25</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="bg-white rounded-3 mt-3">
                      Town hall meeting
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2" className="mb-3 rounded-4 overflow-hidden">
                  <Accordion.Header>
                    <div className="row flex-grow-1 ">
                      <div className="col-2 p-1 text-center fw-bold text-purple">
                        <div className="bg-purple-gradient rounded-top-3 fs-3 ">
                          28
                        </div>
                        <div className="bg-dark-purple  text-white rounded-bottom-3  ">
                          May
                        </div>
                      </div>
                      <div className="col-10">
                        <h5 className="fw-bold">Team Meeting</h5>
                        <h6 className="small opacity-50 ">
                          Lorem ipsum dolor sit amet consectetur...
                        </h6>
                        <div className="d-flex ">
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon
                              icon={faLocationPin}
                              className="me-2"
                            />
                            Location:
                            <span className=" opacity-50 ">Jaywick</span>
                          </span>
                          <span className="mt-2 me-2">
                            <FontAwesomeIcon icon={faUser} className="me-2" />
                            Contacts:
                            <span className=" opacity-50 ">2</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="bg-white rounded-3 mt-3 ">
                      <div>
                        <span className="d-flex align-items-center">
                          <TickIcon width={15} />
                          <h5 className=" p-1 small">location</h5>
                        </span>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className=" ms-4">
              <MyPagination total={50} onPaginate={() => {}} />
            </div>
            <hr className="mt-3 text-secondary" />
          </Tab.Pane>

          <Tab.Pane eventKey="default">default</Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
